import { Directive, Input, OnChanges } from '@angular/core';

import { IScanSummary } from '../../../../../../../shared/interfaces/scan-summaries.interface';
import { $scanSummaries } from '../../../../../../../shared/constants/scan-summaries';
import { $scanAudit } from '../../../../../../../shared/constants/scan-audit';
import { TranslateService } from '../../../../../translate/translate.service';
import { IScanAudit } from '../../../../../../../shared/interfaces/scan-audit.interface';
import { ITableConfig, ITableRow } from '../../../../../components/table/ngb-table/utilities/ngb-table.interface';
import { NgbTableUtilities } from '../../../../../components/table/ngb-table/utilities/ngb-table.utilities';
import { standardFilters } from '../../../../../../../shared/constants/filters';
import { ParsedStandards } from '../../../../../../../shared/constants/standard-parsing';
import { standardNameAndLevel } from '../../../../../../../shared/constants/scanning';
import { IParsedStandard } from '../../../../../../../shared/interfaces/standard-parsing.interface';
import { AccessibilityAuditToolNames, AuditToolNameToAuditType } from '../../../../../../../shared/constants/audit-tool';
import { AuditTypes } from '../../../../../../../shared/constants/audit-types';

const enum $columns {
  standard = 'standard',
  rulesEvaluated = 'rulesEvaluated',
  issuesDiscovered = 'issuesDiscovered',
}

export interface IIssuesByStandard {
  standard: string;
  rulesEvaluated: number;
  issuesDiscovered: number;
}

@Directive()
export abstract class AbstractIssuesByStandardComponent implements OnChanges {
  @Input() public scanSummary: IScanSummary;
  @Input() public auditTool: AccessibilityAuditToolNames;

  public conformanceData: IIssuesByStandard[];
  public tableConfig: ITableConfig;
  public tableData: ITableRow[];
  public includeStandard: IParsedStandard;
  public auditType: AuditTypes;
  public scanAudits: IScanAudit;

  constructor(private translateService: TranslateService) {
    this.auditTool = AccessibilityAuditToolNames.access_engine;
    this.auditType = AuditTypes.accessibility_access;
    this.includeStandard = ParsedStandards[standardNameAndLevel.WCAG_v21_AA];
    this.scanSummary = null;
    this.conformanceData = [];
    this.tableConfig = this.getTableConfig();
    this.tableData = [];
  }

  private getTableConfig(): ITableConfig {
    return {
      caption: this.translateService.instant('findings_discovered'),
      columns: {
        [$columns.standard]: {
          translationKey: 'label_standard',
        },
        [$columns.rulesEvaluated]: {
          translationKey: 'table_header_rules_evaluated',
        },
        [$columns.issuesDiscovered]: {
          translationKey: 'findings_discovered',
        },
      },
      emptyState: {
        iconId: 'file-tray',
        title: this.translateService.instant('there_are_no_failed_findings'),
        subtitle: '',
      },
    };
  }

  protected toTableData(rawData: IIssuesByStandard[]): ITableRow[] {
    return rawData.map((entry: IIssuesByStandard): ITableRow => {
      return {
        data: {
          [$columns.standard]: NgbTableUtilities.textCell({
            text: entry.standard,
          }),
          [$columns.rulesEvaluated]: NgbTableUtilities.textCell({
            text: entry.rulesEvaluated.toString(),
          }),
          [$columns.issuesDiscovered]: NgbTableUtilities.textCell({
            text: String(entry.issuesDiscovered),
          }),
        },
      };
    });
  }

  protected abstract calculateTable(): void;

  public ngOnChanges(): void {
    this.auditType = AuditToolNameToAuditType[this.auditTool];
    this.scanAudits = this.scanSummary[$scanSummaries.scanAuditsId][$scanAudit.audits];
    this.includeStandard = ParsedStandards[this.scanAudits[this.auditType][standardFilters.includeStandard]];
    this.calculateTable();
  }
}
